import axios from 'axios'
import Vue from 'vue'
import { Message } from 'element-ui' // 如果使用 Element UI
import store from '@/store' // 如果使用 Vuex
import router from '@/router' // 如果使用 Vue Router
import { EventBus } from '@/main.js'

// 创建 axios 实例
const http = axios.create({
	baseURL: process.env.VUE_APP_BASE_API, // 从环境变量获取基础 API 地址
	timeout: 10000, // 请求超时时间
	isAuth: true  // 是否需要传token
})

// 请求拦截器
http.interceptors.request.use(
	config => { /* 设置全局配置 */
		// console.log(process.env.VUE_APP_BASE_API)
		const regex = /^(?:https?:\/\/)?(?:[^\/]+)\/([^\/#]+)/i;
		const match = window.location.href.match(regex);
		
		config.headers = {
			...config.headers,
			'Content-Type': 'application/json;charset=UTF-8',
			'System-Key': match ? match[1] : null
		}
		
		let isAuth = config.isAuth
		if(!isAuth) return config
		
		const token = store.getters.token
		if (token) {
			config.headers['Token'] = `${token}`
		}
		return config
	},
	error => {
		// 对请求错误做些什么
		console.error('Request Error:', error)
		return Promise.reject(error)
	}
)

// 响应拦截器
http.interceptors.response.use(
	response => {
		const res = response.data
		
		// 根据你的后端返回结构自定义处理
		if (res.code && res.code != 'S000001') {
			// 显示错误消息
			if(res.code != 'P000002' && res.code != 'B000002' && res.code != 'B000003' && res.code != 'B000004' && res.code != 'B000005'){
				Message({
					message: res.message || 'Error',
					type: 'error'
				})
			}

			// 特定状态码处理
			if (res.code == 'P000002') {
				// 重新登录
				store.dispatch('logout').then(() => {
					EventBus.$emit('show-login', true)
				})
			}
			if (res.code == 'B000002') {
				// 不是会员 弹客服
				EventBus.$emit('service', true)
			}
			if(res.code == 'B000003') {
				// 跳转404
				router.replace('/no-found').catch(error => {
					if (error.name === 'NavigationDuplicated') return
				})
			}
			
			// return Promise.reject(new Error(res.message || 'Error'))
		} 
		return res
	},
	error => {
		console.error('Response Error:', error)

		// 处理 HTTP 状态码
		if (error.response) {
			switch (error.response.status) {
				// case 400:
				// 	error.message = '请求错误'
				// 	break
				// case 401:
				// 	error.message = '未授权，请登录'
				// 	break
				// case 403:
				// 	error.message = '拒绝访问'
				// 	break
				// case 404:
				// 	error.message = `请求地址出错: ${error.response.config.url}`
				// 	break
				// case 500:
				// 	error.message = '服务器内部错误'
				// 	break
				// default:
				// 	error.message = `连接错误 ${error.response.status}`
			}
		}

		Message({
			message: error.message,
			type: 'error'
		})

		return Promise.reject(error)
	}
)

// 全局挂载
Vue.prototype.$http = http

export default http